import { Component } from '@angular/core';

import { CalendarConfigurationFacade } from '../+state/calendar-configuration/calendar-configuration.facade';
import { MonthlyCalendarRibbonType } from '../_models';
import { BuildTripViewType, CalendarViewType, StaffViewType } from '@sd-portal/shared/models';
import { envAccess } from '@sd-portal/shared/functions';

@Component({
  selector: 'sd-portal-calendar-configuration-dialog',
  templateUrl: './calendar-configuration-dialog.component.html',
  styleUrls: ['./calendar-configuration-dialog.component.scss']
})
export class CalendarConfigurationDialogComponent {
  monthlyCalendarRibbonType = MonthlyCalendarRibbonType;
  calendarViewType = CalendarViewType;
  staffViewType = StaffViewType;
  show24Hrs: boolean;
  buildTripViewType = BuildTripViewType;
  constructor(readonly calendarConfigurationFacade: CalendarConfigurationFacade) {
    const envTest = envAccess('test');
    this.show24Hrs = envTest;
  }
}
